import { ErrorMessage } from '@hookform/error-message';
import { Label } from '@repo/shadcn';
import { Controller, useFormContext } from 'react-hook-form';
import { PiPlusCircleDuotone } from 'react-icons/pi';

import { MODAL_ROUTE } from '@/constants';
import { useModal } from '@/hooks';
import { DynamicControl } from '@/shared/dynamic-control.tsx';

import { createProduct } from '../utils/product-inputs';
import { BrandsAutoComplete } from './brands-autocomplete';
import { GenericsAutoComplete } from './generics-autocomplete';

function CreateProductInformation({ onClickFormActionBtn }: any) {
    const { control: formControl } = useFormContext();
    const { openModal } = useModal();

    return (
        <div className=" mt-5 grid grid-cols-2 gap-5 lg:grid-cols-4">
            {createProduct.productInformation.fields?.map((product, i) => (
                <div key={i} className={` ${product.className}`}>
                    <div className="item-center mb-2 flex h-fit justify-between">
                        <Label className="h-fit">{product.label}</Label>
                        {product.actionBtn && (
                            <Label
                                onClick={() =>
                                    onClickFormActionBtn(product.actionBtnLabel)
                                }
                                className="flex cursor-pointer items-center gap-1 text-primary hover:underline"
                            >
                                <PiPlusCircleDuotone
                                    size={16}
                                    className="-mt-1"
                                />
                                {product.actionBtnLabel}
                            </Label>
                        )}
                    </div>
                    <DynamicControl {...product} options={[]} />

                    <ErrorMessage
                        name={product.fieldName}
                        render={({ message }) => (
                            <p className="mt-1 text-sm text-red-600">
                                {message}
                            </p>
                        )}
                    />
                </div>
            ))}
            <Controller
                name={'generic_id'}
                control={formControl}
                render={() => (
                    <>
                        <div className="flex flex-col gap-2">
                            <div className=" flex justify-between">
                                <Label>Generics Name</Label>
                                <Label
                                    onClick={() =>
                                        openModal(
                                            MODAL_ROUTE.CREATE_PRODUCT_GENERIC,
                                        )
                                    }
                                    className="flex cursor-pointer items-center gap-1 text-primary hover:underline"
                                >
                                    <PiPlusCircleDuotone
                                        size={16}
                                        className="-mt-1"
                                    />
                                    Add generic
                                </Label>
                            </div>
                            <GenericsAutoComplete
                                control={formControl}
                                name={'generic_id'}
                            />
                            <ErrorMessage
                                name="generic_id"
                                render={({ message }) => (
                                    <p className="text-sm text-red-600 ">
                                        {message}
                                    </p>
                                )}
                            />
                        </div>
                    </>
                )}
            />
            <Controller
                name={'brand_id'}
                control={formControl}
                render={() => (
                    <div className="flex flex-col gap-2">
                        <div className=" flex justify-between">
                            <Label>Brand Name</Label>
                            <Label
                                onClick={() =>
                                    openModal(MODAL_ROUTE.CREATE_PRODUCT_BRAND)
                                }
                                className="flex cursor-pointer items-center gap-1 text-primary hover:underline"
                            >
                                <PiPlusCircleDuotone
                                    size={16}
                                    className="-mt-1"
                                />
                                Add brand
                            </Label>
                        </div>

                        <BrandsAutoComplete
                            control={formControl}
                            name={'brand_id'}
                        />
                        <ErrorMessage
                            name="brand_id"
                            render={({ message }) => (
                                <p className="text-sm text-red-600 ">
                                    {message}
                                </p>
                            )}
                        />
                    </div>
                )}
            />
        </div>
    );
}

export default CreateProductInformation;
